import React, { ReactNode } from "react";
import style from "./style.module.css";

export interface ISectionProps {
    sectionId: string;
    isLast: boolean;
    children: ReactNode;
}

export function Section(props: ISectionProps) {
    return (
        <section
            id={`${props.sectionId}`}
            className={style.section}
            attr-is-last={props.isLast ? "true" : undefined}
        >
            {props.children}
        </section>
    );
}